export const truncateText = ({ text, maxLength }) => {
    if (text?.length > maxLength) {
        return text.substring(0, maxLength - 3) + '...'
    }
    return text
}